import React from 'react';
import ListDivider from 'react-toolbox/lib/list/ListDivider'
import List from 'react-toolbox/lib/list/List'
import {ListItem} from "react-toolbox/lib/list";

import './log_list.css'

const tableNames = ["Time", "Action", "Description"];

const createLogEntry = (entity) => {

    return (<div className={'LogListItem'}>
        <div className={'LogListItemUnitF'}>{new Date(entity.timestamp).toISOString()}</div>
        <div className={'LogListItemUnit'}>{entity.action}</div>
        <div className={'LogListItemUnit'}>{entity.description}</div>
    </div>)
};

export const LogSensorList = (props) => {

    return (
        <div className='subFormBox'>
            <div className={'listFieldContainer'}>
                {tableNames.map((field, index) => {
                    return (<span key={index} className={'listFieldLog'}> {field} </span>)
                })}
            </div>
            <ListDivider/>
            <List ripple className={'nodeList noCheckBox'}>
                {props.logs.map((entity, key) => {
                    return <ListItem
                        key={key}
                        itemContent={createLogEntry(entity)}
                    />
                })}
            </List>
        </div>
    )




};


// WEBPACK FOOTER //
// ./src/components/DashBoard/AdminNodes/NodeForm/log_list/log_sensor_list.js